import { atom } from 'recoil';
import type { RecoilState } from 'recoil';
import type { StatefulSplitClient } from './StatefulSplitClient';

// @ts-expect-error [EN-10263] - TS2322 - Type 'RecoilState<{ client: null; ready: false; timeout: false; email: string; }>' is not assignable to type 'RecoilState<{ client: StatefulSplitClient | null; ready: boolean; timeout: boolean; email: string; }>'.
export const splitIoState: RecoilState<{
  client: StatefulSplitClient | null;
  ready: boolean;
  timeout: boolean;
  email: string;
}> = atom({
  key: 'splitio',
  default: { client: null, ready: false, timeout: false, email: '' },
  dangerouslyAllowMutability: true,
});
